const UserTypes = Object.freeze({
  UCT: "UCT",
  GCT: "GCT",
  PCT: "PCT",
  MCT: "MCT",
});

export { UserTypes };
